import { useEffect, useState } from 'react';
import useStyles from './style';
import PropTypes from 'prop-types';
import MessageList from './components/MessageList/MessageList';
import MessageAdd from './components/MessageInput/MessageAdd';

const ChatComponent = ({ 
  messages: initialMessages = [], 
  onSend,
  onEdit,
  events,
  onDelete,
  totalMessages,
  loadMore,
  isLoading,
  loadError,
  permissions,
}) => {
  const classes = useStyles();
  const [messages, setMessages] = useState([]);
  const [shouldScrollToBottom, setShouldScrollToBottom] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if(initialMessages.length > 0 && firstLoad) {
      setFirstLoad(false);
      setMessages(initialMessages);
    }
  }, [initialMessages]);

  return (
    <div className={classes.chatContainer}>
      <MessageList
        messages={messages}
        setMessages={setMessages}
        totalMessages={totalMessages}
        loadMore={loadMore}
        onEdit={onEdit}
        events={events}
        onDelete={onDelete}
        isLoading={isLoading}
        loadError={loadError}
        permissions={permissions}
        shouldScrollToBottom={shouldScrollToBottom}
        setShouldScrollToBottom={setShouldScrollToBottom}
      />

      <MessageAdd
        onSend={onSend}
        permissions={permissions}
        setMessages={setMessages}
        setShouldScrollToBottom={setShouldScrollToBottom}
      />
    </div>
  );
};

ChatComponent.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      text: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      user: PropTypes.string.isRequired,
      userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  ),
  onSend: PropTypes.func.isRequired,
  onEdit: PropTypes.func,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
      icon: PropTypes.element,
      disabled: PropTypes.bool,
    }),
  ),
  onDelete: PropTypes.func,
  totalMessages: PropTypes.number,
  loadMore: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  loadError: PropTypes.bool,
  permissions: PropTypes.shape({
    add: PropTypes.bool,
    files: PropTypes.bool,
    edit: PropTypes.bool,
    delete: PropTypes.bool,
  }),
};

ChatComponent.defaultProps = {
  messages: [],
  totalMessages: 0,
  onEdit: null,
  events: [],
  onDelete: null,
  isLoading: false,
  loadError: false,
  permissions: {
    add: false,
    files: false,
    edit: false,
    delete: false,
  },
};

export default ChatComponent;
